"use strict";

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 2px;\n  height: 2px;\n  border-radius: 50%;\n  background: transparent;\n  box-shadow: 0 0 0 rgba(20, 150, 175, 0);\n  z-index: 995;\n  \n  &.pulse {\n    animation: pulse .5s 1;\n  }\n  \n  &.pulse-stepper {\n    animation: pulse-stepper .5s 1;\n    animation-delay: ", "; \n  }\n  \n  @keyframes pulse {\n    0% {\n      background: #1496af;\n      box-shadow: 0 0 0 5px #1496af;\n    }\n    100% {\n      background: transparent;\n      box-shadow: 0 0 0 60px rgba(20, 150, 175, 0);\n    }\n  }\n  \n  @keyframes pulse-stepper {\n    0% {\n      background: #1496af;\n      box-shadow: 0 0 0 5px #1496af;\n    }\n    100% {\n      background: transparent;\n      box-shadow: 0 0 0 36px rgba(20, 150, 175, 0);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _styledComponents2.default.div(_templateObject(), function (props) {
  return props.delay ? props.delay : '0s';
});